import React from 'react';
import PropTypes from 'prop-types';

export default function LoadingIcon(props) {
  const { fill, size, velocity } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      width={size}
      height={size}
      viewBox='25 25 50 50'
    >
      <path
        fill={fill}
        d='M73 50c0-12.7-10.3-23-23-23S27 37.3 27 50m3.9 0c0-10.5 8.5-19.1 19.1-19.1S69.1 39.5 69.1 50'
      >
        <animateTransform
          attributeName='transform'
          attributeType='XML'
          dur={velocity}
          from='0 50 50'
          repeatCount='indefinite'
          to='360 50 50'
          type='rotate'
        />
      </path>
    </svg>
  );
}

LoadingIcon.defaultProps = {
  size: '50',
  velocity: '1s',
  fill: '#ffffff'
};

LoadingIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string,
  velocity: PropTypes.string
};
